import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledRadioGroup, RadioTitle } from './RadioButton.styles.js';
import { RADIO_SIZES } from './RadioButton.constants.js';

var RadioGroup = function RadioGroup(_ref) {
  var groupTitle = _ref.groupTitle,
    groupId = _ref.groupId,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? RADIO_SIZES.REGULAR : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  return (React__default.createElement(StyledRadioGroup, {
      role: "group",
      "aria-labelledby": groupId,
      "data-testid": testId
    }, React__default.createElement(RadioTitle, {
      id: groupId,
      $size: size
    }, groupTitle), children)
  );
};
RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  groupTitle: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(RADIO_SIZES)),
  testId: PropTypes.string
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.js.map
